import React, { Component } from "react";
import { Grid, Button, GridColumn, Icon } from "semantic-ui-react";
import EventsBackgroundColor from "./../Shared/EventsBackgroundColor";
import { BrowserView, MobileView, isBrowser, isMobile, withOrientationChange } from "react-device-detect";
import axios from "axios";
import { Route, IndexRoute } from "react-router";
import { Link } from "react-router-dom";
const eventCat = require("./data/eventCategory.json");
const periodCat = require("./data/periodCategory2.json");
const { apiUrl } = require('./config')
var _ = require('lodash');
const { categObj } = require("./categ");
const timelineData = require("./data/timelinedata-new.json");
const { 
  getCategory,
  fontSizeOptions,
  fontSizeTitle,
  fontSizeCategory,
  fontSizeDesc,
  ImageSizeOptions,
  getMonthName
} = require("../Shared/utils");

function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

function timelineListShowEvent() {
  return `${apiUrl}/api/v2/pages/?type=home.TimelineEvent&fields=*&show_event=true`
}

function getPeriodCategorySnippets() {
  var url = `${apiUrl}/api/v2/snippets/period/?fields=*`
  return axios.get(url)
    .then(res => {
      const data = res.data;
        return data
    })
    .catch(error => {
      console.error(error);
    });
}

function getVolumeCategorySnippets() {
  var url = `${apiUrl}/api/v2/snippets/volume/?fields=*`
  return axios.get(url)
    .then(res => {
      const data = res.data;
        return data
    })
    .catch(error => {
      console.error(error);
    });
}

function getTimelinePeriods() {
  var url = `${apiUrl}/api/v2/pages/?type=home.TimelinePeriod&fields=*`
  return axios.get(url)
    .then(res => {
      const data = res.data;
        return data
    })
    .catch(error => {
      console.error(error);
    });
}

class EventSliderIndexPeriod extends Component {
  state = {
    eventItem: {},
    eventId: ''
  }

  componentWillMount = () =>{
    console.log('EventSliderIndexPeriodProps',this.props)
    var id = window.location.pathname.split('/')
    var eventId = id[2]

    this.setState({
      eventId: eventId,
      timelinePeriods: timelineData
    })

    getPeriodCategorySnippets().then(output => {
      this.setState({
        periods: output.items
      });
    })

    getVolumeCategorySnippets().then(vol => {
      this.setState({
        volumes: vol.items,
      });
    })

    // getTimelinePeriods().then(period => {
    //   var period_sort = _.sortBy(period.items, 'period_id')
    //   period_sort.forEach((item)=>{
    //     item.sub_period.forEach((i, index)=>{
    //       i.value.event.forEach((x, ind)=>{
    //           var dates = JSON.parse(x.event.dates)
    //           var start_month = dates[0].value.month == "" ? ""  : getMonthName(dates[0].value.month) + " "
    //           var start_day = dates[0].value.day == "" ? "" : dates[0].value.day + ", "
    //           var start_year = dates[0].value.year == "" ? "" : dates[0].value.year

    //           x.event['start_date'] = start_day +  start_month + start_year
    //           x.event['category'] = x.event.categories.length == 0 ? '' : x.event.categories[0]
    //           x.event['dates'] = dates
    //           x.event['item_id'] = i.id+ "-" + ind

    //           var item_id = i.id+ "-" + ind
              
    //           if(item_id == eventId){
    //             this.setState({
    //               eventItem: x.event,
    //               period: item
    //             })
    //           }
            
    //       })
    //     })
    //   })

    //   this.setState({
    //     timelinePeriods: period_sort
    //   });
    // })

    timelineData.map((item, ind)=>{
      item.sub_period.map((i)=>{
        i.value.category_page.event_list.map((x)=>{
          x.events.map((ev)=>{
            ev.map((e)=>{
              if(e.value.event.id == eventId){
                this.setState({
                  eventItem: e.value.event,
                  period: item
                })
              }
            })
          })
        })
      })
    })


  }

  handleClick = (value) => {
    window.location.replace(`/epa_timeline/#id${value}`);
  }

  render() {
    console.log("eventslider/STate", this.state);
    var { eventItem } = this.state;
    return (
      <div>

        {isEmpty(eventItem) ? (
          ""
        ) : (
          <div>
            {eventItem.photo == null ? (
              <CatDescription {...this.state} 
                handleClick = {this.handleClick}
              />
            ) : (
              <CatWithImage {...this.state} 
                handleClick = {this.handleClick}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

export default EventSliderIndexPeriod;

const CatWithImage = props => {
  console.log("CatWithImagessssss", props);
  var { eventItem, period, eventId } = props;
  var category = getCategory(eventItem.categories[0].id);
  // var category = eventItem.categories[0];
  var categoryColor = "";

  var startDateDisplay = eventItem.dates.map(item => {
    if (item.type == "start_date") {
      return item.value.year;
    }
  });
  const regex = /(<([^>]+)>)/gi;
  return (
    <div
      className="container-fluid col-xl-12 h-100 period-container bg-img p-0 sss"
      style={{
        backgroundImage: `url('${period.background_image.meta.download_url}')`,
        backgroundColor: `${period.period_color}`,
        backgroundBlendMode: "soft-light"
      }}
    > 
    {/* {isBrowser ? "h-100" : "vh-100"}
    {withOrientationChange ? "h-100" : "vh-100"} */}
      <EventsBackgroundColor category={categoryColor} className={"period-container"}>
     
      {/* <EventsBackgroundColor category={category} height={"h-100"}> */}
        <Grid className="m-0 pt-0 pl-3 pr-3">
            <Grid.Column width={6} className="pt-1">
              <Button className="rounded-0 btn-event-back p-1 font-weight-bold" content="Scroll Down" onClick={props.handleClick.bind(this, eventItem.id)}>
                <Icon name="long arrow alternate left" />
                Back
              </Button>
            </Grid.Column>
            <Grid.Column width={10}>
              <p className="event-slider-period-category text-white text-uppercase text-right ">
                {period.period_slider_display_name}
              </p>
            </Grid.Column>
        </Grid>
        <div className="center-div">
        <Grid className="m-0">
          <Grid.Column width={16} className="p-0">
            <img className="event-slider-image" align="left" src={eventItem.photo.url} />
            
          </Grid.Column>
          <div className="font-style-7 text-white m-auto pt-1" dangerouslySetInnerHTML={{ __html: `${eventItem.photo.caption}` }} />
        </Grid>
        <Grid className="m-0">
          <Grid.Column width={2}></Grid.Column>
          <Grid.Column width={12} className="px-0 pb-0 pt-2">
            <p className="event-title-historical text-white mt-3 mb-2">
            {eventItem.display_name == "" || eventItem.display_name == null
                              ? eventItem.complete_start_date
                              : eventItem.display_name}
              <span className={`event-category text-white  ${category == '' ? "d-none" : ""}`}>| {category}</span>
            </p>
            <div className="col-md-6 mt-2 p-0">
              <hr className="hr-gold mb-2 mt-2" />
            </div>

            <p className="event-description-historical text-white font-style-3">
              {/* {eventItem.description.replace(regex, "")} */}
              <div dangerouslySetInnerHTML={{ __html: `${eventItem.description}` }} />
            </p>
          </Grid.Column>
          <Grid.Column width={2}></Grid.Column>
        </Grid>
        </div>
      </EventsBackgroundColor>
    </div>
  );
};

const CatDescription = props => {
  // console.log("CatDescription", props)
  var { eventItem, period } = props;
  // console.log("CatDescriptionID", categories(eventItem.categories[0].id))
  // var category = eventItem.categories[0];
  var category = getCategory(eventItem.categories[0].id);
  var categoryColor = "";
  var startDateDisplay = eventItem.dates.map(item => {
    if (item.type == "start_date") {
      return item.value.year;
    }
  });
  const regex = /(<([^>]+)>)/gi;
  return (
    <div
      className="container-fluid col-xl-12 h-100 period-container bg-img p-0 ss2"
      style={{
        backgroundImage: `url('${period.background_image.meta.download_url}')`,
        backgroundColor: `${period.period_color}`,
        backgroundBlendMode: "soft-light"
      }}
    >
      <EventsBackgroundColor category={categoryColor} className={"period-container"}>
      
        <Grid className="m-0 pt-0 pl-3 pr-3">
            <Grid.Column width={6} className="pt-1">
              <Button className="rounded-0 btn-event-back p-1 font-weight-bold" content="Scroll Down" onClick={props.handleClick.bind(this, eventItem.id)}>
                <Icon name="long arrow alternate left" />
                Back
              </Button>
            </Grid.Column>
            <Grid.Column width={10} className="pt-2">
              <p className="event-slider-period-category text-white text-uppercase text-right ">
                {period.period_slider_display_name}
              </p>
            </Grid.Column>
        </Grid>
        <div className="center-div">
        <Grid className="m-0">
          <Grid.Column width={2}></Grid.Column>
          <Grid.Column width={12} className="p-0">
            <p className="event-title-historical text-white">
            {eventItem.display_name == "" || eventItem.display_name == null
                              ? eventItem.complete_start_date
                              : eventItem.display_name}
              <span className={`event-category text-white  ${category == '' ? "d-none" : ""}`}>| {category}</span>
            </p>

            <div className="col-md-6 mt-2 p-0">
              <hr className="hr-gold mb-2 mt-2" />
            </div>

            <p className="event-description-historical text-white font-style-3">
              {/* {eventItem.description.replace(regex, "")} */}
              <div dangerouslySetInnerHTML={{ __html: `${eventItem.description}` }} />
            </p>
          </Grid.Column>
          <Grid.Column width={2}></Grid.Column>
        </Grid>
        </div>
      </EventsBackgroundColor>
    </div>
  );
};
